<script>
import requestFunctions from "@src/functions/requestFunctions"

export default {

  data() {
    return {
      session: null,
      connected: null,
      auth_code: null,
      qr_code_url: null
    }
  },

  async mounted () {

  },

  methods: {
    async connect(){

      this.$parent.config.session = this.gen_uuid(); 
      this.$parent.save(false);

      // console.log(this.$parent.uuid)

      this.qr_code_url = 'https://api.client.za-bota.com/v1/bots/channels/auth/' + this.$parent.uuid;

      this.connected = true;
      this.auth_code = true;
    },

    gen_uuid() {
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
    }
  }

}
</script>

<template>
  <div>

      <div v-if="auth_code">

          <div style="margin: 30px auto; border: 1px solid rgba(189, 188, 188, 0.125) !important; width: 300px; height: 300px; display: flex; align-items: center; justify-content: center; position: relative">            
            <img :src="qr_code_url" alt="" style="width: 300px; height: 300px; position: absolute">
            <img src="@assets/images/preloader.svg" alt="" style="width: 30px; position: absolute">
          </div>

          <hr style="margin-bottom: 30px; margin-top: 30px">
          <p>Для сканирования QR-кода, используйте QR-сканер внутри приложения WhatsApp на своём телефоне.</p>

          <p>Для этого откройте WhatsApp на телефоне:</p>
          <p>
            <span style="font-weight: bold">На Android:</span> откройте экран Чаты > Меню > WhatsApp Web.<br>
            <span style="font-weight: bold">На iPhone:</span> откройте Настройки > WhatsApp Web.<br>
            <span style="font-weight: bold">На Windows Phone:</span> откройте Меню > WhatsApp Web.
          </p>
          <p>
            После сканирования QR кода и подключения WhatsApp, нажмите кнопку "Сохранить"
          </p>
      </div>

      <div v-if="!auth_code">
        <b-form-group
          label="Номер телефона"
          label-for="config_phone"
        >
          <b-form-input
              id="config_phone"
              v-model="$parent.config.phone"
              placeholder=""
          />
        </b-form-group>
        <div class="alert alert-warning alert-dismissible light" style="font-size: 12px; margin-top: 15px">
          Необходимо вводить начиная с кода страны без символа +. Пример для России: 79990000000
        </div>
      </div>

      <hr style="margin-bottom: 0 !important; margin-top: 30px">

      <div class="btns-container" style="justify-content: flex-start; padding-left: 0px; padding-top: 25px">
        <button v-if="connected" type="button" class="btn btn-primary" style="margin-right: 10px" @click="$parent.save">Сохранить</button>
        <button v-if="!connected" type="button" class="btn btn-primary" style="margin-right: 10px" @click="connect">Подключить</button>
        <button type="button" class="btn btn-light" @click="$parent.close">Отменить</button>
      </div>
    
  </div>     
</template>
